(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velorea-feedback"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('velorea-feedback')){
  customElements.define('velorea-feedback',class extends HTMLElement{
    connectedCallback(){
      if(this.feedbackReady)return;
      this.feedbackReady=true;
      this.track=this.querySelector('.velorea-feedback__track');
      this.previous=this.querySelector('[data-feedback-previous]');
      this.next=this.querySelector('[data-feedback-next]');
      if(!this.track)return;
      this.update=()=>{
        const overflow=this.track.scrollWidth>this.track.clientWidth+2;
        this.previous.hidden=!overflow;
        this.next.hidden=!overflow;
        this.previous.disabled=this.track.scrollLeft<=2;
        this.next.disabled=this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-2;
      };
      const move=direction=>{
        const card=this.track.querySelector('.velorea-feedback__card');
        if(card)this.track.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).columnGap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      };
      this.previous.addEventListener('click',()=>move(-1));
      this.next.addEventListener('click',()=>move(1));
      this.track.addEventListener('scroll',this.update,{passive:true});
      this.track.addEventListener('keydown',event=>{
        if(event.target!==this.track)return;
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}
      });
      this.observer=new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback(){this.observer?.disconnect();this.feedbackReady=false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velorea-premium-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('velorea-campaign-slider')) {
  customElements.define('velorea-campaign-slider', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      clearTimeout(this.autoplayTimer);
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.velorea-art-banner__track');
      this.slides = Array.from(this.querySelectorAll('.velorea-art-banner__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-slide]'));
      if (!this.track || !this.slides.length) return;
      this.autoplayPaused = false;
      let hovering = false;
      let touching = false;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const pauseButton = this.querySelector('[data-autoplay]');
      const schedule = () => {
        clearTimeout(this.autoplayTimer);
        if (this.autoplayPaused || hovering || touching || document.hidden || motion.matches || this.contains(document.activeElement)) return;
        this.autoplayTimer = setTimeout(() => { go(current() + 1); schedule(); }, 3000);
      };
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovering = true; clearTimeout(this.autoplayTimer); } }, {signal});
      this.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { hovering = false; schedule(); } }, {signal});
      this.addEventListener('pointerdown', () => { touching = true; clearTimeout(this.autoplayTimer); }, {signal});
      document.addEventListener('pointerup', () => { touching = false; schedule(); }, {signal});
      document.addEventListener('pointercancel', () => { touching = false; schedule(); }, {signal});
      this.addEventListener('focusin', () => clearTimeout(this.autoplayTimer), {signal});
      this.addEventListener('focusout', () => queueMicrotask(schedule), {signal});
      document.addEventListener('visibilitychange', schedule, {signal});
      motion.addEventListener('change', schedule, {signal});
      pauseButton?.addEventListener('click', () => {
        this.autoplayPaused = !this.autoplayPaused;
        pauseButton.setAttribute('aria-pressed', String(this.autoplayPaused));
        pauseButton.setAttribute('aria-label', this.autoplayPaused ? 'Play automatic banners' : 'Pause automatic banners');
        pauseButton.querySelector('span').textContent = this.autoplayPaused ? '▶' : 'Ⅱ';
        schedule();
      }, {signal});
      const current = () => Math.round(Math.abs(this.track.scrollLeft) / this.track.clientWidth);
      const go = (index) => {
        const next = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({left: next * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => go(current() + Number(button.dataset.direction)), {signal}));
      this.dots.forEach(button => button.addEventListener('click', () => go(Number(button.dataset.slide)), {signal}));
      this.track.addEventListener('scroll', () => {
        const index = current();
        this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
        this.slides.forEach((slide, i) => {
          const link = slide.querySelector('a');
          if (link) link.tabIndex = i === index ? 0 : -1;
        });
      }, {passive: true, signal});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          go(current() + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, {signal});
      this.slides.forEach((slide, i) => { if (i > 0) slide.querySelector('a')?.setAttribute('tabindex', '-1'); });
      schedule();
    }
    disconnectedCallback() { this.abort?.abort(); clearTimeout(this.autoplayTimer); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
